import { render, staticRenderFns } from "./page-select.vue?vue&type=template&id=4c282e65&scoped=true"
import script from "./page-select.vue?vue&type=script&lang=js"
export * from "./page-select.vue?vue&type=script&lang=js"
import style0 from "./page-select.vue?vue&type=style&index=0&id=4c282e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c282e65",
  null
  
)

export default component.exports